import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const messageDataClassName = DataClassName.MESSAGE
const messageEndpoint = PisaDataClassEndpoint.MESSAGE

export function pisaMessageDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(messageDataClassName, {
    title: messageDataClassName,
    restApi: createPisaRestApiConfig(messageEndpoint),
    attributes,
  })
}
